import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { FullScreenNotificationLayout } from "@/layouts/FullScreenNotificationLayout/FullScreenNotificationLayout";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { FullScreenNotificationBox } from "@/modules/theme/components/FullScreenNotificationBox";
import { PageMeta } from "@/modules/theme/components/PageMeta";

import { ReactComponent as TestPassedIcon } from "./test-passed-icon.svg";

const translationNamespace = "pages/TestPassedPage";

export const TestPassedPage = () => {
  const { t } = useTranslation(translationNamespace);
  const history = useHistory();

  return (
    <FullScreenNotificationLayout
      onSubmit={() =>
        history.replace(authenticatedRouting.buildUrl("tutorials"))
      }
      variant="success"
    >
      <PageMeta title={t("You passed!")} />
      <FullScreenNotificationBox
        title={t("You passed!")}
        text={t("Congratulation you have passed the test.")}
      >
        <TestPassedIcon />
      </FullScreenNotificationBox>
    </FullScreenNotificationLayout>
  );
};
